import { IsNotEmpty, IsArray, ValidateNested } from 'class-validator';

import { ContentSurveysPassingQuestion } from '../../types';

export class ContentSurveysPassingDto {
  @ValidateNested({ each: true })
  @IsArray()
  @IsNotEmpty()
  questions: ContentSurveysPassingQuestion[];
}
